import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Builder, builder, BuilderComponent } from '@builder.io/react';

import useCache from '../../hooks/useCache';

import './components/usp/Usp';
import './components/heading/Heading';
import './components/inspiration/InspirationBanner';
import './components/layout/Dummy';
import './components/layout/FullRowGrid';
import './components/layout/TwoColumnGrid';
import './components/layout/ThreeColumnGrid';
import './components/layout/SixColumnGrid';
import './components/layout/RowGridWithImage';
import './components/layout/FourEightGrid';
import './components/message/infomessage/InfoMessage';
import './components/banner/Banner';
import './components/categoryelement/CategoryElement'
import './components/recentlyviewed/RecentlyViewed';
import './components/brands/Brands';
import './components/subcategories/SubCategories';
import './components/button/Button';
import './components/products/Products';
import './components/algoliaproducts/AlgoliaProducts';
import './components/contact/Contact';
import './components/faq/short/FaqShortList';
import './components/faq/menu/FaqMenu';
import './components/faq/qa/Qa';
import './components/contactform/Contactform';
import './components/returnform/Returnform';
import './components/breadcrumb/BreadcrumbBuilder';
import './components/quoteform/Quoteform';
import './components/trendingitems/TrendingItems';
import './components/newsletter/NewsletterSubscribed';
import './components/newsletter/NewsletterUnsubscribed';
import './components/accountpageheading/AccountPageHeading';
import './components/accountoverviewheading/AccountOverviewHeading';
import './components/accounttile/AccountTile';
import './components/accounttilewrapper/AccountTileWrapper';
import './components/bbwvideo/BBWVideo';
import './components/bbwchannel/BBWChannel';
import './components/blog/Blog';

builder.init('196c263ab2894a338e807c5bee37e4df');


const BuilderContent = ({ model = 'page', url = null, renderLoading = null, renderNotFound = null }) => {

    const cache = useCache();
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(false);

    const isLive = !Builder.isEditing && !Builder.isPreviewing;
    const cacheKey = model + (url !== null ? ':' + url : '');


    useEffect(() => {
        const cached = cache.get(cacheKey);

        // Reset previous state to null or set the cached current page
        setPage(cached || null);
    }, [cacheKey]);


    useEffect(() => {
        
        let cancelRequest = false;

        const fetchContent = async () => {
            try {
                setLoading(true);

                const content = await builder.get(model, { url: url }).promise();
                //const content = await builder.getAll(model, { url: url, limit: 1 });

                if (!cancelRequest) {

                    setPage(content);
                    
                    // Do not cache not found (undefined)
                    if (content) {
                        cache.set(cacheKey, content);
                    }

                    setLoading(false);
                }
            } catch (error) {
                //console.log(error);
                setLoading(false);
            }
        }

        fetchContent();

        return () => {
            cancelRequest = true;
        };
    }, [model, url]);


    if (!page && loading) {
        return renderLoading && renderLoading();
    }

    // Page is undefined when not found in builder
    if (page === undefined) {
        return renderNotFound && renderNotFound();
    }

    // Page is null on first render
    if (page === null) { return null; }

    return (
        <>
            <Helmet>
                <title>{page?.data.title || ''}</title>
                <meta name="description" content={page?.data.description || ''} />
                {/* custom field */}
                {page?.data.canonicalUrl ? <link rel="canonical" href={page.data.canonicalUrl} /> : null}
            </Helmet>

            <BuilderComponent model={model} content={page} />
        </>
    );
}

export default BuilderContent;